<template>
  <v-app>
    <v-system-bar height="30" dark>
      <div>
        <v-icon small>mdi-qrcode-scan</v-icon>
        Relatório de entrada
      </div>
      <v-spacer></v-spacer>
      <span>{{ currentTime | date("DD/MM/YYYY [às] HH:mm") }}</span>
    </v-system-bar>
    <v-main>
      <v-container class="d-flex flex-column gap-4">
        <SessionDetailsCard :session="session" />
        <SessionEntriesDetails
          :session="session"
          :report="report"
          :loading="loading"
        />
        <SessionEntriesRegistry
          :session="session"
          :entries="entries"
          :loading="loading"
        />
        <!-- <SessionEntriesTimeline :session="session" :report="report" /> -->

        <v-dialog
          :value="!!error"
          max-width="400"
          persistent
          content-class="rounded-lg"
        >
          <v-card class="d-flex flex-column align-center justify-center pa-6">
            <v-icon x-large color="error">mdi-alert</v-icon>
            <h5>{{ error?.title }}</h5>
            <p>{{ error?.message }}</p>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import moment from "moment";
import REPORT from "@/services/staff/entrance-report";
import SessionDetailsCard from "@/components/staff/entranceReport/SessionDetailsCard.vue";
import SessionEntriesDetails from "@/components/staff/entranceReport/SessionEntriesDetails.vue";
// import SessionEntriesTimeline from "@/components/staff/entranceReport/SessionEntriesTimeline.vue";
import SessionEntriesRegistry from "@/components/staff/entranceReport/SessionEntriesRegistry.vue";

export default {
  name: "EntranceReport",
  metaInfo: {
    title: "Relatório de entrada",
  },
  components: {
    SessionDetailsCard,
    SessionEntriesDetails,
    // SessionEntriesTimeline,
    SessionEntriesRegistry,
  },
  data: () => ({
    loading: false,
    error: null,
    token: null,
    session: null,
    currentTime: new Date(),
    interval: null,
    timeout: null,
    report: null,
    lastSync: null,
    entries: [],
    entriesIds: new Set(),
    expiration: null,
  }),
  methods: {
    loadToken() {
      try {
        this.token = atob(this.$route.params.token || "");
        if (!this.token) throw {};
        const [, payloadBase64] = this.token.split(".");
        const payload = JSON.parse(atob(payloadBase64));
        if (!payload.id) throw {};
        if (payload.exp) {
          this.expiration = moment(payload.exp * 1000);
          if (payload.exp < moment().unix())
            throw {
              title: "O link expirou",
              message: "Esse link não é mais válido",
            };
        }
        return payload;
      } catch (e) {
        throw {
          title: e?.title || "O link não é válido",
          message:
            e?.message ||
            "Verifique se o link está correto, caso o problema persista, solicite um novo link ao organizador do evento",
        };
      }
    },
    async init() {
      try {
        this.loading = true;
        this.loadToken();

        const data = await REPORT.get(this.token);
        this.session = data.session;

        this.getReport();
      } catch (error) {
        this.error = {
          title: error?.title || "Ocorreu um erro",
          message: error?.message || "Tente novamente mais tarde",
        };
      } finally {
        this.loading = false;
      }
    },
    async getReport() {
      try {
        this.loading = true;
        clearTimeout(this.timeout);
        if (this.expiration && this.expiration < moment()) {
          this.error = {
            title: "O link expirou",
            message: "Esse link não é mais válido",
          };
          return;
        }

        const { report } = await REPORT.report(this.token, this.lastSync);

        this.report = {
          byAction: report.byAction,
          byTicketBlock: report.byTicketBlock,
        };

        report.lastEntries.forEach((entry) => {
          if (this.entriesIds.has(entry.id)) return;
          this.entries.push(entry);
          this.entriesIds.add(entry.id);
        });

        this.lastSync = report.lastEntries[0]?.createdAt || null;

        this.timeout = setTimeout(() => {
          this.getReport();
        }, 10000);
      } catch (error) {
        this.error = {
          title: error?.title || "Ocorreu um erro",
          message: error?.message || "Tente novamente mais tarde",
        };
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.init();
    this.interval = setInterval(() => {
      this.currentTime = new Date();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style></style>
